import React from 'react'
import Radio from "@material-ui/core/Radio";

import { ListItem } from './AssetCollectionOption.styles'


const AssetCollectionOption = props => {
    const isChecked = props.selectedCollection === props.collectionID;
    return (
      <ListItem
        className="collection-option"
        style={
          props.collectionID === props.selectedCollection
            ? { backgroundColor: "#75db00", color: "#000 !important" }
            : {}
        }
      >
        <Radio
          checked={props.collectionID === props.selectedCollection}
          id={props.collectionID}
          value={props.collectionID}
          onChange={props.onCollectionChange}
          className="radio-button"
        />

        <label
          style={
            props.collectionID === props.selectedCollection
              ? {color: "#000 !important" }
              : {}
          }
          htmlFor={props.collectionID}
        >
          {props.collectionName}
        </label>
      </ListItem>
    );
}

export default AssetCollectionOption



// WEBPACK FOOTER //
// ./src/components/Admin/LessonBuilder/AssetCollections/AssetCollectionOption.tsx